import { createActionCreator } from '../core-action-creators';
import { TimeActionType, UpdateDisplayTimePayload } from './time-actions';

/**
 * Action creators
 */

export const updateDisplayTime = createActionCreator<UpdateDisplayTimePayload>(TimeActionType.UpdateDisplayTime);
